import React, { useCallback, useEffect, useState } from "react";

import { Box, Button, Container, Typography } from "@mui/material";
import http from "src/utils/http";
import SC from "src/assets/images/survey-thank.png";
import PaypalSuccessPayments from "../success-payments/Paypal";
import { useTranslation } from "react-i18next";
import LoadingScreen from "src/components/LoadingScreen";
import { useSnackbarContext } from "src/context/SnackbarContext";

const PaypalFialedPayments = ({ session_slug }) => {
  const { showSnackbar } = useSnackbarContext();
  const [isLoading, setIsLoading] = useState(true);
  const [details, setDetails] = useState(null);
  const { t } = useTranslation();

  const getBooking = useCallback(() => {
    http
      .get(`/api/general/individual/appointment/details/bysession-slug`, {
        params: {
          sent_confirmation_email: false,
          session_slug,
          base_url: window.location.origin,
          payment_type: "paypal",
        },
      })
      .then(({ data }) => {
        if (data.message === "success") {
          showSnackbar(
            "Unable to complete booking, Payment unsuccessful.",
            "success"
          );
          setDetails(data.session_details);
        }
      })
      .catch((err) => console.log(err.message))
      .finally(() => setIsLoading(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session_slug]);

  useEffect(() => {
    getBooking();
  }, [getBooking]);

  const getPaymentUrl = () => {
    try {
      if (details?.custom_data) {
        return JSON.parse(details.custom_data)?.paypal_config?.payment_url ?? null;
      }
      return (
        JSON.parse(details?.session_records_firstentry?.appointment?.booking ?? "{}")
          ?.paypal_config?.payment_url ?? null
      );
    } catch (error) {
      return null;
    }
  };

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (Boolean(parseInt(details?.paypal_ispaid))) {
    return <PaypalSuccessPayments session_slug={session_slug} />;
  }

  return (
    <Container maxWidth={"lg"}>
      <Box
        sx={{
          borderRadius: "16px",
          p: { xs: "32px 20px", md: "56px 72px" },
          mt: { xs: "24px", md: "64px" },
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          height: "calc(100vh - 100px)",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Box>
            <img
              src={SC}
              alt={"Treffas Logo"}
              style={{
                width: "104px",
                height: "104px",
              }}
            />
          </Box>

          <Box mt={"16px"} mb={"24px"}>
            <Typography
              sx={{
                display: "inline-block",
                px: "12px",
                py: "4px",
                borderRadius: "999px",
                backgroundColor: "#FFF2F0",
                color: "#D14343",
                fontSize: "12px",
                fontWeight: 600,
                letterSpacing: "0.02em",
                mb: "12px",
              }}
            >
              PayPal
            </Typography>

            <Typography
              sx={{
                fontFamily: "var(--font-grenettepromedium)",
                fontSize: "22px",
                lineHeight: "30px",
                color: "#060A2D",
              }}
            >
              {t("booking.redirect.payment.paypal.failed.label.unpaid")}
            </Typography>

            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "31px",
                color: "#060A2D",
              }}
            >
              {t("booking.redirect.payment.paypal.failed.label.unpaid.limit")}
            </Typography>

            <Typography
              sx={{
                mt: "8px",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "22px",
                color: "#6E757C",
              }}
            >
              Payment was cancelled or not completed. You can safely retry using
              your payment link.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Button
              variant="contained"
              fullWidth={false}
              sx={{
                textTransform: "inherit",
                borderRadius: "12px",
                fontSize: "14px",
                padding: "10px 16px",
                lineHeight: "22px",
                fontWeight: 500,
                height: "48px",
                minWidth: "220px",
              }}
              onClick={() => {
                const paymenturl = getPaymentUrl();
                if (paymenturl) {
                  window.open(paymenturl, "_blank");
                } else {
                  showSnackbar(
                    t("booking.confirm.error.payment_url_notfound"),
                    "error"
                  );
                }
              }}
            >
              {t("booking.button.open_payment_url")} (PayPal)
            </Button>

            <Button
              variant="outlined"
              sx={{
                textTransform: "inherit",
                borderRadius: "12px",
                fontSize: "14px",
                padding: "10px 16px",
                lineHeight: "22px",
                fontWeight: 500,
                height: "48px",
                minWidth: "180px",
              }}
              onClick={() => {
                window.location.href = "/";
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default PaypalFialedPayments;

// const styles = {
//   label: {
//     color: "var(--color-gray-700)",
//     fontWeight: 400,
//     fontSize: "14px",
//     lineHeight: "31px",
//     textTransform: "capitalize",
//   },
//   value: {
//     color: "#060A2D",
//     fontWeight: 400,
//     fontSize: "14px",
//     lineHeight: "24px",
//   },
// };
